<template>
    <nav class="header">
        <div class="container">
            <div class="naw-wrapper">
                <div class="header-left">
                    <router-link to="/" class="logo">
                        <img src="@/assets/img/Logo.svg" alt="">
                    </router-link>
                    <h3 v-if="!inventory" class="inventoryh3">Invenroty</h3>  
                </div>
                
                <div class="header-rigth">
                    <div class="header-btn">
                    <router-link to="/inventory" class="nav-inventory"
                    v-if="inventory" @click="inventoryDisplay">Inventory</router-link>
                    <router-link to="/Request/" class="nav-request2" @click="requestClick(id)"
                    v-if="$route.name === 'InventoryCar'">apply for this vehicle</router-link> 
                    <router-link to="/Request" class="nav-request" 
                    v-if="$route.name != 'Request' && $route.name != 'RequestCar' && $route.name != 'InventoryCar'">Request a car</router-link> 
                    </div>
                    <ul>
                        <div class="hamburger" v-if="validate === false">
                            <img src="../assets/img/BurgerMenu.png" v-if="!mobileNav" @click="toggleMobleNav" key="menu" alt=""/>
                            <img src="../assets/img/BurgerMenuExt.png" v-if="mobileNav" @click="toggleMobleNav" key="clear"  alt=""/>
                        </div>
                        <transition name="menu-transition">
                            <div class="menu" :class="{ hide }" v-show="mobileNav">
                                <li class="inventory-hamburger">
                                    <router-link to="/Inventory">Inventory</router-link>
                                </li>
                                <li class="menu-link" @click="openValidate()">
                                    <p>Contact us</p>
                                </li>
                                <li class="menu-link" v-for="(menu, index) in headerMenu" :key="index">
                                    <router-link :to="menu.path">
                                        {{ menu.name }}
                                    </router-link>
                                </li>

                                <div class="contactus" v-if="validate === true">
                                    <img src="../assets/img/contact-us/Close.png" @click="validate = false">
                                    <h3 v-if="formSucces === false">We can't wait to hear from you!</h3>
                                    <form class="contactus-form" v-if="formSucces === false" @submit.prevent="submitHandler">
                                        <input type="text" class="input-name" placeholder="Your Name" 
                                        v-model="state.name"
                                        :class="v$.name.$error === true ? 'input-error'
                                        : 'input-done'">
                                        <span v-if="v$.name.$error">{{ v$.name.$errors[0].$message }}</span>
                                        <input type="text" class="input-number" placeholder="Phone Number"
                                        v-model="state.phone"
                                        :class="v$.phone.$error === true ? 'input-error'
                                        : 'input-done'">
                                        <span v-if="v$.phone.$error">{{ v$.phone.$errors[0].$message }}</span>
                                        <input type="text" class="input-email" placeholder="Email Address"
                                        v-model="state.email"
                                        :class="v$.email.$error === true ? 'input-error'
                                        : 'input-done'">
                                        <span v-if="v$.email.$error">{{ v$.email.$errors[0].$message }}</span>
                                    </form>
                                    <button type="submit" @click="submitForm()" v-if="formSucces === false">contact me</button>
                                    <div class="contactus-soc" v-if="formSucces === false">
                                        <h4>You can contact us yourself</h4>
                                        <div class="contactus-soc_links">
                                            <a href="#"><img src="@/assets/img/Instagram.svg" alt="Instagram"></a>
                                            <a href="#"><img src="@/assets/img/Facebook.svg" alt="Facebook"></a>
                                            <a href="#"><img src="@/assets/img/YouTube.svg" alt="YouTube"></a>
                                            <a href="#"><img src="@/assets/img/contact-us/Email.png" alt="Email"></a>
                                        </div>
                                    </div>
                                    <div class="form-succes" v-if="formSucces === true">
                                        <img src="../assets/img/contact-us/Success.png" alt="">
                                        <div class="form-succes_main">
                                            <h3>Application Successful!</h3>
                                            <p>Our manager will contact you in the nearest time.</p>
                                        </div>
                                    </div>
                                </div>
                                

                                <div class="soc-burger_top">
                                    <a href="#"><img src="@/assets/img/Instagram.svg" alt="Instagram"></a>
                                    <a href="#"><img src="@/assets/img/Facebook.svg" alt="Facebook"></a>
                                    <a href="#"><img src="@/assets/img/YouTube.svg" alt="YouTube"></a>
                                </div>
                            </div>
                        </transition>
                    </ul>
                </div>
            </div>   
        </div> 
    </nav>
</template>

<script>
    import useValidate from '@vuelidate/core'
    import { required, helpers, minLength, email, numeric} from '@vuelidate/validators'
import { scrollTop } from 'dom7'
    import { reactive, computed } from 'vue'

export default {
    setup(){
        const state = reactive({
            name: '',
            phone: '',
            email: '',
        })

        const rules = computed(() => {
            return{
                name: { required, minLength: minLength(6) },
                phone: { required, minLength: minLength(10), numeric },
                email: { required, email }, 
            }
        })

        const v$ = useValidate(rules, state)

        return{
            state,
            v$
        }
    },

    data() {
        return{
            headerMenu: [
                {name: 'About VAC', path: '/about'},
                {name: 'Loan Rates', path: '/loan'},
                {name: 'Video', path: '/video'},
                {name: 'Blog', path: '/blog'},
                {name: 'Calculate', path: '/calculate'}
            ],
            mobileNav: false,
            hide: true,
            validate: false,    
            formSucces: false, 
            inventory: true       
        }
    },
    methods: {
        toggleMobleNav(){
            this.mobileNav = !this.mobileNav;
        },
        openValidate(){
            this.validate = !this.validate;               
        },
        submitForm(){
            this.v$.$validate()
            if(!this.v$.$error){
                this.formSucces = !this.formSucces;
            } 
        },
        inventoryDisplay(){
            if(this.$route.name == 'Inventory'){
                this.inventory = false
            } else{
                this.inventory = true
            }
        },
        headerTop(){
            let header = document.querySelector('.header')
            // window.addEventListener("scroll", function() {
            // console.log(header.getBoundingClientRect());
            //})
            let scrollpos = window.scrollY
            
            const add_class_on_scroll = () => header.classList.add("bg-hed")
            const remove_class_on_scroll = () => header.classList.remove("bg-hed")

            window.addEventListener('scroll', function() { 
                scrollpos = window.scrollY;

                if (scrollpos >= 1) { add_class_on_scroll() }
                else { remove_class_on_scroll() }
            })
        },
        requestClick(id){
            id = this.$route.query.inventory
            this.$router.push({name: 'RequestCar', query: {'Request': id}})
        }
    },
    watch: {
        $route: {
            deep: true,
            handler () {
                this.hide = true;
                this.mobileNav = false;
            }
        },
        mobileNav: {
            immediate: true,
            handler(val) {
           // document.body.classList.toggle('lock', val);
            document.documentElement.classList.toggle('lock', val);
            },
        },

    },
    mounted() {
        this.headerTop()
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/breakpoints.scss';

.header {
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: #FFFFFF;
    font-family: 'Gilroy700';
    box-shadow: 0px 1px 0px #D7D7D7;
    position: fixed;
    z-index: 10;
    margin-right: calc(-100vw - -100%);
}
.naw-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;

    @include breakpoints(md){
        height: 65px;
    }
    @include breakpoints(sm){
        height: 55px;
    }
}
.logo {
    img{
        display: block;
        @include breakpoints(sm){
            width: 82px;
            height: 24px;
        }
    }
}

.inventoryh3{
    font-family: 'Gilroy700';
    font-size: 25px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #41456B;
}

.header-left{
    display: flex;
    align-items: center;
    gap: 40px;
}


.header-rigth{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 63px;
    position: relative;

    @include breakpoints(sm){
        gap: 23px;
    }
}

.header-btn{
    display: flex;
    gap: 20px;
    padding-right: 50px;

    @include breakpoints(md){
        padding-right: 20px;
    }
    @include breakpoints(sm){
        padding-right: 0;
    }
}

.nav-inventory {
    border: 1px solid #7481FF;
    border-radius: 2px;
    padding: 16px 17px;
    font-size: 16px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #7481FF;

    @include breakpoints(md){
        padding: 12px 13px;
        font-size: 14px;
        line-height: 20px;
    }
    @include breakpoints(sm){
        display: none;
    }
}
.nav-request, .nav-request2 {
    background: #7481FF;
    padding: 16px 17px;
    font-size: 16px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #FFFFFF;

    @include breakpoints(md){
        padding: 12px 13px;
        font-size: 14px;
        line-height: 20px;
    }
    @include breakpoints(sm){
        padding: 10px;
        line-height: 14px;
    }
}
.nav-request2{
    @include breakpoints(sm){
        display: none;
    }
}
.hamburger {
    font-size: 24px;
    cursor: pointer;
    position: absolute;
    top: 7px;
    display: flex;
    align-items: center;
    right: 0;

    @include breakpoints(sm){
        position: relative;
        top: 0;
    }

    img{
        z-index: 4;
        transition: .3s ease all;

        @include breakpoints(sm){
            width: 27px;
            height: 25px;
        }
    }
}

.menu {
    position: fixed;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 570px;
    height: 100%;
    background: #FFFFFF;
    right: 0; 
    top: 0;
    z-index: 3;
    padding-top: 130px;
    padding-left: 60px;
    overflow-y: auto;

    @include breakpoints(md){
        width: 350px;
        padding-top: 100px;
    }

    @include breakpoints(sm){
        width: 100%;
        padding-top: 130px;

    }
}

.menu-link a, .menu-link p, .inventory-hamburger a{
    display: inline;
    font-size: 25px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #41456B;
    cursor: pointer;
}
.inventory-hamburger{
    display: none;
    @include breakpoints(sm){
        display: block;
    }
}
.soc-burger {
    &_top {
        display: flex;
        gap: 10px;
        margin-top: 240px;

        @include breakpoints(sm){
            margin-top: 100px;
            margin-bottom: 40px;
        }
    }
}

.menu-transition-enter-active,
.menu-transition-leave-active{
    transition: .7s ease all;
}

.menu-transition-enter-from,
.menu-transition-leave-to{
    transform: translateX(570px);
}

.menu-transition-enter-to{
    transform: translateX(0);
}

.lock{
    overflow-y: hidden;
}


                                            //Contact Us

.contactus {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    z-index: 5;
    left: 0;
    padding: 28px 120px 0 60px;
    @include breakpoints(md){
        padding: 28px 40px 0 40px;
    }
    @include breakpoints(sm){
        padding: 14px 20px 0 20px;
    }

    img{
        cursor: pointer;
    }

    h3{
        font-family: 'Gilroy700';
        font-size: 30px;
        line-height: 140%;
        color: #41456B;
        padding: 40px 0 60px;
        @include breakpoints(sm){
            font-size: 24px;
            padding: 47px 0 20px;
        }
    }
    button{
        background: #7481FF;
        border-radius: 2px;
        font-family: 'Gilroy700';
        font-size: 16px;
        line-height: 14px;
        text-align: center;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: #FFFFFF;
        padding: 16px;
        margin-top: 40px;
        width: 100%;
        @include breakpoints(sm){
            padding: 10px;
            font-size: 14px;
            margin-top: 30px;
        }
    }
}
.contactus-form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input{
        border-radius: 2px;
        font-family: 'Gilroy500';
        font-size: 16px;
        line-height: 159%;
        padding: 10px 20px 10px 44px;
        color: #606276;
    }
    span{
        font-family: 'Gilroy400';
        font-size: 14px;
        line-height: 159%;
        color: #F54E4E;
    }

}
.input-error{
    border: 1px solid #F54E4E;
}
.input-done{
    border: 1px solid #D7D7D7;
}
.input-name{
    background-image: url(../assets/img/contact-us/Name.png);
    background-repeat: no-repeat;
    background-position: 10px 10px;
}
.input-number{
    background-image: url(../assets/img/contact-us/Phone.png);
    background-repeat: no-repeat;
    background-position: 10px 10px;
}
.input-email{
    background-image: url(../assets/img/contact-us/Mail.png);
    background-repeat: no-repeat;
    background-position: 10px 10px;
}
.contactus-soc {
    margin-top: 60px;

    h4{
        font-family: 'Gilroy600';
        font-size: 20px;
        line-height: 25px;
        color: #41456B;
        @include breakpoints(sm){
            font-size: 18px;
        }
     }
}
.contactus-soc_links {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}


                                                //FORM-Succes

.form-succes {
    img{
        margin-top: 60px;
        @include breakpoints(sm){
            margin-top: 136px;
        }
    }
}
.form-succes_main {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 40px;
    @include breakpoints(sm){
        margin-top: 10px;
    }

    h3{
        padding: 0;
    }

    p{
        font-family: 'Gilroy400';
        font-size: 16px;
        line-height: 180%;
        letter-spacing: 0.02em;
        color: #606276;
        width: 60%;
        @include breakpoints(sm){
            width: 80%;
        }
    }
}
.bg-hed{
    box-shadow: 0px 20px 25px rgb(0 0 0 / 10%);
}


</style>